import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OutlinedTextarea from 'components/Kizen/Textarea';

export const DescriptionInput = ({
  id,
  description,
  onChange,
  error,
  validate,
  clearError,
}) => {
  const { t } = useTranslation();

  const [stagedDescription, setDescription] = useState(description);

  const onChangeDescription = useCallback(
    (value) => {
      setDescription(value);
      clearError('description');
    },
    [clearError]
  );
  const onBlurDescription = useCallback(() => {
    onChange(id, 'description', stagedDescription);
  }, [onChange, stagedDescription, id]);

  return (
    <OutlinedTextarea
      value={stagedDescription}
      label={t('Action Description')}
      placeholder={t('Enter Action Description')}
      onChange={onChangeDescription}
      onBlur={onBlurDescription}
      error={error}
      validate={validate}
      rows="5"
    />
  );
};
